import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Neuen Benutzer anlegen", -1)
const _hoisted_3 = { class: "wizard-form steps-basic wizard clearfix" }
const _hoisted_4 = { class: "steps steps-container" }
const _hoisted_5 = { role: "tablist" }
const _hoisted_6 = ["aria-disabled"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "number" }
const _hoisted_9 = {
  key: 0,
  class: "card"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-white" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, " Stammdaten ")
], -1)
const _hoisted_11 = { class: "card-body" }
const _hoisted_12 = { class: "form-group row" }
const _hoisted_13 = { class: "col-lg-9" }
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = { class: "invalid-feedback" }
const _hoisted_16 = { class: "form-group row" }
const _hoisted_17 = { class: "col-lg-9" }
const _hoisted_18 = ["placeholder"]
const _hoisted_19 = { class: "invalid-feedback" }
const _hoisted_20 = { class: "form-group row" }
const _hoisted_21 = { class: "col-lg-3 col-form-label" }
const _hoisted_22 = { class: "col-lg-9" }
const _hoisted_23 = ["placeholder"]
const _hoisted_24 = { class: "form-group row" }
const _hoisted_25 = { class: "col-lg-9" }
const _hoisted_26 = { class: "input-group" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text bg-secondary" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon-warning2" })
  ])
], -1)
const _hoisted_28 = ["placeholder"]
const _hoisted_29 = { class: "invalid-feedback" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("small", { class: "text-muted" }, [
  /*#__PURE__*/_createElementVNode("b", null, "! An diese E-Mailadresse wird der Registrierungslink gesendet.")
], -1)
const _hoisted_31 = { class: "card-footer d-flex flex-row justify-content-end" }
const _hoisted_32 = {
  key: 1,
  class: "card"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-white" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, " Erweiterte Stammdaten ")
], -1)
const _hoisted_34 = { class: "card-body" }
const _hoisted_35 = { class: "form-group row" }
const _hoisted_36 = { class: "col-lg-3 col-form-label" }
const _hoisted_37 = { class: "col-lg-9" }
const _hoisted_38 = ["placeholder"]
const _hoisted_39 = { class: "form-group row" }
const _hoisted_40 = { class: "col-lg-3 col-form-label" }
const _hoisted_41 = { class: "col-lg-9" }
const _hoisted_42 = ["placeholder"]
const _hoisted_43 = { class: "form-group row" }
const _hoisted_44 = { class: "col-lg-3 col-form-label" }
const _hoisted_45 = { class: "col-lg-9" }
const _hoisted_46 = ["placeholder"]
const _hoisted_47 = { class: "form-group row" }
const _hoisted_48 = { class: "col-lg-3 col-form-label" }
const _hoisted_49 = { class: "col-lg-9" }
const _hoisted_50 = ["placeholder"]
const _hoisted_51 = { class: "form-group row" }
const _hoisted_52 = { class: "col-md-3 col-form-label" }
const _hoisted_53 = { class: "col-md-9" }
const _hoisted_54 = ["value"]
const _hoisted_55 = { class: "card-footer d-flex flex-row justify-content-between" }
const _hoisted_56 = {
  key: 2,
  class: "card"
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-white" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, " Kontaktnummer ")
], -1)
const _hoisted_58 = { class: "card-body" }
const _hoisted_59 = { class: "form-group row" }
const _hoisted_60 = { class: "col-md-9" }
const _hoisted_61 = { class: "input-group" }
const _hoisted_62 = { class: "input-group-prepend" }
const _hoisted_63 = ["value"]
const _hoisted_64 = ["disabled"]
const _hoisted_65 = { class: "invalid-feedback" }
const _hoisted_66 = { class: "form-group row" }
const _hoisted_67 = { class: "col-md-9" }
const _hoisted_68 = { class: "input-group" }
const _hoisted_69 = { class: "input-group-prepend" }
const _hoisted_70 = ["value"]
const _hoisted_71 = ["disabled"]
const _hoisted_72 = { class: "invalid-feedback" }
const _hoisted_73 = { class: "form-group row" }
const _hoisted_74 = { class: "col-md-9" }
const _hoisted_75 = ["disabled"]
const _hoisted_76 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Keine Nummer ausgewählt", -1)
const _hoisted_77 = ["disabled"]
const _hoisted_78 = ["disabled"]
const _hoisted_79 = { class: "invalid-feedback d-block" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_81 = /*#__PURE__*/_createTextVNode(" Sie müssen mindestens eine Nummer ausgewählt haben um die Nummer als Interventionsnummer auswählen zu können ")
const _hoisted_82 = { class: "card-footer d-flex flex-row justify-content-between" }
const _hoisted_83 = {
  key: 3,
  class: "card"
}
const _hoisted_84 = /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-white" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, " Rechte ")
], -1)
const _hoisted_85 = { class: "card-body" }
const _hoisted_86 = { class: "table-responsive" }
const _hoisted_87 = { class: "table" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "w-100 font-weight-bold" }, "Recht"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-weight-bold" }, "Aktiv")
  ])
], -1)
const _hoisted_89 = /*#__PURE__*/_createElementVNode("td", null, " Anlagen schalten ", -1)
const _hoisted_90 = { class: "custom-control custom-switch custom-control-dark" }
const _hoisted_91 = ["checked"]
const _hoisted_92 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "slc_arming_read"
}, null, -1)
const _hoisted_93 = /*#__PURE__*/_createElementVNode("td", null, " Firmendaten / Ansprechpartner ändern ", -1)
const _hoisted_94 = { class: "custom-control custom-switch custom-control-dark" }
const _hoisted_95 = ["checked"]
const _hoisted_96 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "slc_company_read"
}, null, -1)
const _hoisted_97 = /*#__PURE__*/_createElementVNode("td", null, " Benutzer anzeigen ", -1)
const _hoisted_98 = { class: "custom-control custom-switch custom-control-dark" }
const _hoisted_99 = ["checked"]
const _hoisted_100 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "slc_user_read"
}, null, -1)
const _hoisted_101 = /*#__PURE__*/_createElementVNode("td", null, " Benutzer anlegen / bearbeiten ", -1)
const _hoisted_102 = { class: "custom-control custom-switch custom-control-dark" }
const _hoisted_103 = ["checked"]
const _hoisted_104 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "slc_user_write"
}, null, -1)
const _hoisted_105 = /*#__PURE__*/_createElementVNode("td", null, " Rechnung ", -1)
const _hoisted_106 = { class: "custom-control custom-switch custom-control-dark" }
const _hoisted_107 = ["checked"]
const _hoisted_108 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "slc_bill_read"
}, null, -1)
const _hoisted_109 = /*#__PURE__*/_createElementVNode("td", null, " Verträge ", -1)
const _hoisted_110 = { class: "custom-control custom-switch custom-control-dark" }
const _hoisted_111 = ["checked"]
const _hoisted_112 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "slc_contracts_read"
}, null, -1)
const _hoisted_113 = { class: "card-footer d-flex flex-row justify-content-between" }
const _hoisted_114 = {
  key: 4,
  class: "card"
}
const _hoisted_115 = /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-white" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, " Projektberechtigung ")
], -1)
const _hoisted_116 = { class: "card-body" }
const _hoisted_117 = { class: "table-responsive" }
const _hoisted_118 = {
  cellspacing: "2",
  cellpadding: "0",
  border: "0",
  class: "table"
}
const _hoisted_119 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "d-none d-md-table-cell font-weight-bold" }, "ProjektId"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-nowrap font-weight-bold" }, "Projekt Name"),
    /*#__PURE__*/_createElementVNode("th", { class: "d-none d-md-table-cell w-100 font-weight-bold" }, "Projekt Anschrift"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-weight-bold" }, "Aktion")
  ])
], -1)
const _hoisted_120 = { id: "" }
const _hoisted_121 = { class: "d-none d-md-table-cell" }
const _hoisted_122 = { class: "d-none d-md-table-cell" }
const _hoisted_123 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_124 = { class: "custom-control custom-switch custom-control-dark" }
const _hoisted_125 = ["id", "checked", "onChange"]
const _hoisted_126 = ["for"]
const _hoisted_127 = { class: "card-footer d-flex flex-row justify-content-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step, stepIndex) => {
            return (_openBlock(), _createElementBlock("li", {
              key: stepIndex,
              role: "tab",
              class: _normalizeClass([{'current':stepIndex==_ctx.activeStep}, {'done':step.done&&stepIndex!=_ctx.activeStep, 'disabled':!step.done}]),
              "aria-disabled": !step.done
            }, [
              _createElementVNode("a", {
                href: "",
                class: _normalizeClass({'disabled':!step.done}),
                onClick: _withModifiers(($event: any) => (_ctx.go(stepIndex)), ["prevent"])
              }, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(stepIndex), 1),
                _createTextVNode(" " + _toDisplayString(step.name), 1)
              ], 10, _hoisted_7)
            ], 10, _hoisted_6))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_ctx.activeStep==1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", {
                    class: _normalizeClass(["col-lg-3 col-form-label", {'text-danger':_ctx.user.firstName.error}])
                  }, _toDisplayString(_ctx.user.firstName.name), 3),
                  _createElementVNode("div", _hoisted_13, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(["form-control", {'is-invalid':_ctx.user.firstName.error}]),
                      required: "",
                      placeholder: _ctx.user.firstName.name,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.firstName.value) = $event))
                    }, null, 10, _hoisted_14), [
                      [_vModelText, _ctx.user.firstName.value]
                    ]),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.user.firstName.error), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("label", {
                    class: _normalizeClass(["col-lg-3 col-form-label", {'text-danger':_ctx.user.lastName.error}])
                  }, _toDisplayString(_ctx.user.lastName.name), 3),
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(["form-control", {'is-invalid':_ctx.user.lastName.error}]),
                      required: "",
                      placeholder: _ctx.user.lastName.name,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.lastName.value) = $event))
                    }, null, 10, _hoisted_18), [
                      [_vModelText, _ctx.user.lastName.value]
                    ]),
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.user.lastName.error), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.user.jobTitle.name), 1),
                  _createElementVNode("div", _hoisted_22, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      required: "",
                      placeholder: _ctx.user.jobTitle.name,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.jobTitle.value) = $event))
                    }, null, 8, _hoisted_23), [
                      [_vModelText, _ctx.user.jobTitle.value]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", {
                    class: _normalizeClass(["col-lg-3 col-form-label", {'text-danger':_ctx.user.email.error}])
                  }, _toDisplayString(_ctx.user.email.name), 3),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _hoisted_27,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(["form-control", {'is-invalid':_ctx.user.email.error}]),
                        required: "",
                        placeholder: _ctx.user.email.name,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.email.value) = $event))
                      }, null, 10, _hoisted_28), [
                        [_vModelText, _ctx.user.email.value]
                      ]),
                      _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.user.email.error), 1)
                    ]),
                    _hoisted_30
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("button", {
                  class: "btn btn-secondary",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.next(2)))
                }, "Weiter")
              ])
            ]))
          : (_ctx.activeStep==2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.user.street.name), 1),
                    _createElementVNode("div", _hoisted_37, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        required: "",
                        placeholder: _ctx.user.street.name,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.user.street.value) = $event))
                      }, null, 8, _hoisted_38), [
                        [_vModelText, _ctx.user.street.value]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.user.houseNumber.name), 1),
                    _createElementVNode("div", _hoisted_41, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        required: "",
                        placeholder: _ctx.user.houseNumber.name,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.user.houseNumber.value) = $event))
                      }, null, 8, _hoisted_42), [
                        [_vModelText, _ctx.user.houseNumber.value]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.user.zipCode.name), 1),
                    _createElementVNode("div", _hoisted_45, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        required: "",
                        placeholder: _ctx.user.zipCode.name,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.user.zipCode.value) = $event))
                      }, null, 8, _hoisted_46), [
                        [_vModelText, _ctx.user.zipCode.value]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.user.city.name), 1),
                    _createElementVNode("div", _hoisted_49, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        required: "",
                        placeholder: _ctx.user.city.name,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.user.city.value) = $event))
                      }, null, 8, _hoisted_50), [
                        [_vModelText, _ctx.user.city.value]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.user.country.name), 1),
                    _createElementVNode("div", _hoisted_53, [
                      _withDirectives(_createElementVNode("select", {
                        readonly: "readonly",
                        tabindex: "11",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.user.country.value) = $event))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country, index) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: index,
                            value: country.code
                          }, _toDisplayString(country.name), 9, _hoisted_54))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.user.country.value]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("button", {
                    class: "btn btn-light",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.back(1)))
                  }, "Zurück"),
                  _createElementVNode("button", {
                    class: "btn btn-secondary",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.next(3)))
                  }, "Weiter")
                ])
              ]))
            : (_ctx.activeStep==3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                  _hoisted_57,
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("label", {
                        class: _normalizeClass(["col-md-3 col-form-label", {'text-danger':_ctx.user.tel.error}])
                      }, _toDisplayString(_ctx.user.tel.name), 3),
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                          _createElementVNode("span", _hoisted_62, [
                            _withDirectives(_createElementVNode("select", {
                              class: "form-control",
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.user.areaCodeTel.value) = $event))
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.phoneCodes, (code, cIndex) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: code,
                                  value: cIndex
                                }, _toDisplayString(cIndex) + " ( " + _toDisplayString(code) + " )", 9, _hoisted_63))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, _ctx.user.areaCodeTel.value]
                            ])
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            class: _normalizeClass(["form-control", {'is-invalid':_ctx.user.tel.error}]),
                            type: "text",
                            placeholder: "",
                            autocomplete: "off",
                            disabled: _ctx.user.tel.disabled,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.user.tel.value) = $event)),
                            onFocusout: _cache[14] || (_cache[14] = ($event: any) => (_ctx.validatePhoneNumber('tel'))),
                            onKeyup: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onTypingNumber('tel')))
                          }, null, 42, _hoisted_64), [
                            [_vModelText, _ctx.user.tel.value]
                          ]),
                          _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.user.tel.error), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_66, [
                      _createElementVNode("label", {
                        class: _normalizeClass(["col-md-3 col-form-label", {'text-danger':_ctx.user.mobil.error}])
                      }, _toDisplayString(_ctx.user.mobil.name), 3),
                      _createElementVNode("div", _hoisted_67, [
                        _createElementVNode("div", _hoisted_68, [
                          _createElementVNode("span", _hoisted_69, [
                            _withDirectives(_createElementVNode("select", {
                              class: "form-control",
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.user.areaCodeMobil.value) = $event))
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.phoneCodes, (code, cIndex) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: code,
                                  value: cIndex
                                }, _toDisplayString(cIndex) + " ( " + _toDisplayString(code) + " )", 9, _hoisted_70))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, _ctx.user.areaCodeMobil.value]
                            ])
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            class: _normalizeClass(["form-control", {'is-invalid':_ctx.user.mobil.error}]),
                            type: "text",
                            placeholder: "",
                            autocomplete: "off",
                            disabled: _ctx.user.mobil.disabled,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.user.mobil.value) = $event)),
                            onFocusout: _cache[18] || (_cache[18] = ($event: any) => (_ctx.validatePhoneNumber('mobil'))),
                            onKeyup: _cache[19] || (_cache[19] = ($event: any) => (_ctx.onTypingNumber('mobil')))
                          }, null, 42, _hoisted_71), [
                            [_vModelText, _ctx.user.mobil.value]
                          ]),
                          _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.user.mobil.error), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_73, [
                      _createElementVNode("label", {
                        class: _normalizeClass(["col-md-3 col-form-label", {'text-danger':_ctx.user.interventionNumber.error}])
                      }, _toDisplayString(_ctx.user.interventionNumber.name), 3),
                      _createElementVNode("div", _hoisted_74, [
                        _withDirectives(_createElementVNode("select", {
                          class: _normalizeClass(["form-control", {'is-invalid':_ctx.user.tel.error}]),
                          disabled: _ctx.user.interventionNumber.disabled,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.user.interventionNumber.value) = $event))
                        }, [
                          _hoisted_76,
                          _createElementVNode("option", {
                            value: "mobil",
                            disabled: _ctx.user.mobil.value === '' || _ctx.user.mobil.error
                          }, " Handy: " + _toDisplayString(_ctx.user.mobil.value), 9, _hoisted_77),
                          _createElementVNode("option", {
                            value: "tel",
                            disabled: _ctx.user.tel.value === '' || _ctx.user.tel.error
                          }, " Festnetz: " + _toDisplayString(_ctx.user.tel.value), 9, _hoisted_78)
                        ], 10, _hoisted_75), [
                          [_vModelSelect, _ctx.user.interventionNumber.value]
                        ]),
                        _createElementVNode("div", _hoisted_79, [
                          _createTextVNode(_toDisplayString(_ctx.user.interventionNumber.error) + " ", 1),
                          _hoisted_80,
                          _hoisted_81
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_82, [
                    _createElementVNode("button", {
                      class: "btn btn-light",
                      onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.back(2)))
                    }, "Zurück"),
                    _createElementVNode("button", {
                      class: "btn btn-secondary",
                      onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.next(4)))
                    }, "Weiter")
                  ])
                ]))
              : (_ctx.activeStep==4)
                ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                    _hoisted_84,
                    _createElementVNode("div", _hoisted_85, [
                      _createElementVNode("div", _hoisted_86, [
                        _createElementVNode("table", _hoisted_87, [
                          _hoisted_88,
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                              _hoisted_89,
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_90, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    class: "custom-control-input",
                                    id: "slc_arming_read",
                                    checked: _ctx.user.rights.arming.write,
                                    onChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.user.rights.arming.write = !_ctx.user.rights.arming.write))
                                  }, null, 40, _hoisted_91),
                                  _hoisted_92
                                ])
                              ])
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_93,
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_94, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    class: "custom-control-input",
                                    id: "slc_company_read",
                                    checked: _ctx.user.rights.company.write,
                                    onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.user.rights.company.write = !_ctx.user.rights.company.write))
                                  }, null, 40, _hoisted_95),
                                  _hoisted_96
                                ])
                              ])
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_97,
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_98, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    class: "custom-control-input",
                                    id: "slc_user_read",
                                    checked: _ctx.user.rights.user.read,
                                    onChange: _cache[25] || (_cache[25] = ($event: any) => (_ctx.user.rights.user.read = !_ctx.user.rights.user.read))
                                  }, null, 40, _hoisted_99),
                                  _hoisted_100
                                ])
                              ])
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_101,
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_102, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    class: "custom-control-input",
                                    id: "slc_user_write",
                                    checked: _ctx.user.rights.user.write,
                                    onChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.user.rights.user.write = !_ctx.user.rights.user.write))
                                  }, null, 40, _hoisted_103),
                                  _hoisted_104
                                ])
                              ])
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_105,
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_106, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    class: "custom-control-input",
                                    id: "slc_bill_read",
                                    checked: _ctx.user.rights.invoice.read,
                                    onChange: _cache[27] || (_cache[27] = ($event: any) => (_ctx.user.rights.invoice.read = !_ctx.user.rights.invoice.read))
                                  }, null, 40, _hoisted_107),
                                  _hoisted_108
                                ])
                              ])
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_109,
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_110, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    class: "custom-control-input",
                                    id: "slc_contracts_read",
                                    checked: _ctx.user.rights.contracts.read,
                                    onChange: _cache[28] || (_cache[28] = ($event: any) => (_ctx.user.rights.contracts.read = !_ctx.user.rights.contracts.read))
                                  }, null, 40, _hoisted_111),
                                  _hoisted_112
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_113, [
                      _createElementVNode("button", {
                        class: "btn btn-light",
                        onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.back(3)))
                      }, "Zurück"),
                      _createElementVNode("button", {
                        class: "btn btn-secondary",
                        onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.next(5)))
                      }, "Weiter")
                    ])
                  ]))
                : (_ctx.activeStep==5)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                      _hoisted_115,
                      _createElementVNode("div", _hoisted_116, [
                        _createElementVNode("div", _hoisted_117, [
                          _createElementVNode("table", _hoisted_118, [
                            _hoisted_119,
                            _createElementVNode("tbody", _hoisted_120, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project, index) => {
                                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                  _createElementVNode("td", _hoisted_121, _toDisplayString(project.pid), 1),
                                  _createElementVNode("td", null, _toDisplayString(project.p_firma), 1),
                                  _createElementVNode("td", _hoisted_122, [
                                    _createTextVNode(_toDisplayString(project.p_strasse) + " " + _toDisplayString(project.p_hnr) + " ", 1),
                                    _hoisted_123,
                                    _createTextVNode(" " + _toDisplayString(project.p_plz) + " " + _toDisplayString(project.p_ort), 1)
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("div", _hoisted_124, [
                                      _createElementVNode("input", {
                                        type: "checkbox",
                                        class: "custom-control-input",
                                        id: 'custom-switch-'+index,
                                        checked: _ctx.user.rights.projects.includes(project.pid),
                                        onChange: ($event: any) => (_ctx.onProjectRightChange($event, project.pid))
                                      }, null, 40, _hoisted_125),
                                      _createElementVNode("label", {
                                        class: "custom-control-label",
                                        for: 'custom-switch-'+index
                                      }, null, 8, _hoisted_126)
                                    ])
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_127, [
                        _createElementVNode("button", {
                          class: "btn btn-light",
                          onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.back(4)))
                        }, "Zurück"),
                        _createElementVNode("button", {
                          class: "btn btn-primary",
                          onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.saveUser && _ctx.saveUser(...args)))
                        }, "Speichern und anlegen")
                      ])
                    ]))
                  : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}